import { t } from './../i18n';
import $http from './../common/http';
import { isOverseasByDomainName } from './ip-tools';
import { beaconReport, execCommandCopy, isMobile, isiPad, getInstallState, isWxworkInAndroid, filterXss } from './../common/util';
import Toast from './../components/Toast/Toast';
import {
  isTestEnv,
  getRequest,
  isWxwork,
  setCookie,
  addURLSearch,
  isIOS,
  isWeChat,
  isLocalEnv,
  isPreReleaseEnv,
} from '..//web-tools/utils/util';
import { VOOV_MEETING, TENCENT_MEETING, JUMP_TYPE, VOOV_ANRD_PKG_NAME } from '../common/constants';
import { MEETING_STATE } from '../web-tools/utils/constant';
import config from './../config/index';

const IS_I18N = process.env.IS_I18N === 'true';

export const loadMeetingInfo = () => new Promise((resolve, reject) => {
  import(/* webpackChunkName: 'meetingInfo' */ './meetingInfo.js')
    .then((res) => {
      resolve(res.default);
    })
    .catch((err) => {
      console.error(err);
      reject(err);
    });
});

// 电话号码复制
export const telEntryDialogCopyBtnI18n = (phone, countryName) => {
  if (isMobile()) {
    window.location.href = `tel:${phone}`;
  } else {
    execCommandCopy(`${phone} (${countryName})`);
    Toast(t('电话号码已复制到剪切板'));
  }
};

/**
 * i18n专用：填充电话入会弹窗的html（两个弹窗：PC端与移动端）
 * @param {string} pageName
 * @param {object} userPstnInfo
 */
export const fillTelMeetingModalHtml = (pageName, userPstnInfo) => {
  const mobileModalPstnItemsEl = document.querySelector('#mQrcodeDialog .dialog-wrap-items');
  const pcModalPstnItemsEl = document.querySelector('#telEntryDialogCtrl .dialog-wrap-content');

  const getMobilePstnItemStr = (phone, countryName, countryCode) => `<div class="dialog-wrap-item" onclick="${pageName}.telEntryDialogCopyBtnI18n('${phone}', '${countryName}', '${countryCode}')">
    <span class="item-phone-num">${phone}</span>
    <span class="item-phone-txt">(${countryName})</span>
  </div>`;
  const getPcPstnItemStr = (phone, countryName, countryCode) => `<div class="dialog-wrap-item">
        <span class="item-txt">${phone} (${countryName})</span>
        <span class="item-btn" onclick="${pageName}.telEntryDialogCopyBtnI18n('${phone}', '${countryName}', '${countryCode}')">${t('复制')}</span>
    </div>`;

  if (
    typeof userPstnInfo === 'object'
    && Array.isArray(userPstnInfo.phone_list)
  ) {
    const countryCode = userPstnInfo.country_code;
    const countryName = userPstnInfo.country_name;
    const phoneList = userPstnInfo.phone_list;

    if (isMobile()) {
      mobileModalPstnItemsEl.innerHTML = phoneList
        .map(el => getMobilePstnItemStr(el.phone_num, countryName, countryCode))
        .join('\n');
    } else {
      pcModalPstnItemsEl.innerHTML = phoneList
        .map(el => getPcPstnItemStr(el.phone_num, countryName, countryCode))
        .join('\n');
    }
  }
};

/**
 * i18n专用：根据用户id获取pstn信息
 * @param {Object} reqData
 * @returns
 */
export const getUserPstn = (reqData) => {
  const reqUrl = 'v2/common/config/user-pstn';
  return $http
    .get({
      url: reqUrl,
      data: reqData,
      response: res => res,
    })
    .catch((err) => {
      console.error('getUserPstn', err);
      window.$util.Raven(`tm-Fatal: ${reqUrl} request exception!`, {
        err,
        reqUrl,
        reqData,
      });
      beaconReport(`web_${reqUrl}_result`, { err_code: 2 });
    });
};

const checkVoovInstall = () => new Promise((resolve) => {
  // 目前腾讯会议和voov的ios scheme一样，所以存在用户安装腾讯会议未安装voov该接口依然返回true，需要后续终端支持区分
  getInstallState(isIOS() ? 'iphone' : '', isIOS() ? '' : VOOV_ANRD_PKG_NAME).then((res) => {
    console.log('>>>>>checkVoovInstall getInstallState', res);
    if (res) {
      // 是否安装结果信息存在err_msg结构里
      const msg = res.err_msg || '';
      if (msg.indexOf('get_install_state:yes') >= 0) {
        resolve(true);
      }
      if (msg.indexOf('get_install_state:no') >= 0) {
        resolve(false);
      }
    }
  });
});

/**
 * 根据ip判断是否为大陆，如果不为大陆，跳转到voov的详情页
 * @param {boolean} jump 是否跳转
 * @param {*} jumpType 跳转类型 DETAIL: 1, PMI: 2
 */
const jumpToVoovDetailIfOverseas = async (jump, jumpType) => {
  let url = '';
  if (jump && !isWxwork()) { // 临时方案，等企业微信支持voov域名后去掉
    const regex = /&isOverseas=[0-9]+/;
    let searchValue = window.location.search.replace(regex, '');
    searchValue = filterXss(searchValue);
    // 微信中跳转voov前帮助其判断是否本地安装voov，voov受微信白名单限制无法自行判断
    let isVoovInstall = -1;
    if (isMobile() && isWeChat()) {
      isVoovInstall = await checkVoovInstall();
    }
    if (jumpType === JUMP_TYPE.DETAIL) {
      // 区分测试环境
      if (isTestEnv()) {
        url = `${VOOV_MEETING.TEST_DETAIL_PREFIX}${searchValue}&originOverseas=0`;
      } else {
        url = `${VOOV_MEETING.DETAIL_PREFIX}${searchValue}&originOverseas=0`;
      }
    }
    if (jumpType === JUMP_TYPE.PMI) {
      if (isTestEnv()) {
        url = `${VOOV_MEETING.TEST_PMI_PREFIX}${searchValue}&originOverseas=0`;
      } else {
        url = `${VOOV_MEETING.PMI_PREFIX}${searchValue}&originOverseas=0`;
      }
    }
    if (url) {
      if (isVoovInstall !== -1) {
        url = addURLSearch(url, { is_voov_install: !!isVoovInstall });
      }
    }
  }
  return url;
};

/**
 * 根据ip判断是否为大陆，如果为大陆，跳转到tencent的详情页
 * @param {boolean} mainland
 * @param {*} jumpType 跳转类型 DETAIL: 1, PMI: 2
 */
const jumpToTencentDetailIfMainland = (jump, jumpType) => {
  // TODO 国内测试环境跳转还需国内同学确认
  let url = '';
  if (jump) {
    const regex = /&isOverseas=[0-9]+/;
    const searchValue = window.location.search.replace(regex, '');

    if (jumpType === JUMP_TYPE.DETAIL) {
      url = `${TENCENT_MEETING.DETAIL_PREFIX}${filterXss(searchValue)}&originOverseas=1`;
    }
    if (jumpType === JUMP_TYPE.PMI) {
      url = `${TENCENT_MEETING.PMI_PREFIX}${filterXss(searchValue)}&originOverseas=1`;
    }
  }
  return url;
};

/**
 * 查询用户地区
 *
 * 国内ip 访问国内、访问海外
 * 海外ip 访问国内、访问海外
 */
const jumpByUserRegion = () => new Promise((resolve, reject) => {
  const reqUrl = 'v2/common/ip/location';
  const ip = getRequest('location_info');
  const postData = ip ? { ip } : null;
  $http
    .post({
      url: reqUrl,
      data: postData,
      response: (res) => {
        resolve(res);
      },
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
});

const jumpRegionCallback = (jumpType, countryCodes) => {
  let jumpUrl = '';

  if ( // 用户在 国内(中国)
    countryCodes === 'cn'
  ) {
    // 访问了 “国外VooV域名”
    if (isOverseasByDomainName() === 'yes') {
      jumpUrl = jumpToTencentDetailIfMainland(true, jumpType);
    }
  } else { // 用户在 国外
    // 访问了 “国内域名”
    if (isOverseasByDomainName() === 'no') {
      jumpUrl = jumpToVoovDetailIfOverseas(true, jumpType);
    }
  }

  return jumpUrl;
};

/**
 * 用户依赖本地cookie做地域跳转
 * @param {*} jumpType - JUMP_TYPE: DETAIL: 1; PMI: 2;
 */
export const jumpByCountryWithCookie = async (jumpType) => {
  let willJump = false;

  const res = await jumpByUserRegion();
  console.log('>>>>>>>>jump ByUserRegion res', res);
  if (res && res.code === 0) {
    const { data: { country_codes: countryCodes } } = res;

    setCookie('detail_country_code', countryCodes, 1);
    willJump = jumpRegionCallback(jumpType, countryCodes);
  }

  return willJump;
};

export const setDocumentTitle = () => {
  document.title = t(config.APP_NAME);
};

/**
 * 是否展示小程序入会入口
 * @param {*} show
 * @param {*} isPmi
 */
export const showMiniProgramButton = (show, isPmi = false) => {
  let $show = show;
  /**
   * SaaS 版本: !process.env.WEMEET_PARAM_PRIVATE = true
   * 私有化版本: process.env.WEMEET_PARAM_PRIVATE 有值，string
   */
  if (process.env.WEMEET_PARAM_PRIVATE) { // 私有化版本
    $show = false;
  }

  const mainButtonsContainer = document.getElementById('mainButtons');
  const miniProgramElement = document.getElementById('mpJoinBtnCtrl');
  const pmiMeetingInfoElement = document.getElementById('tm-pmi-meeting-info-and-join-meeting-container');
  if ($show) {
    // 国际化的版本无小程序入口
    if (miniProgramElement) {
      miniProgramElement.style.display = 'block';
    }
    if (isPmi) {
      mainButtonsContainer.style.bottom = '40px';
    } else {
      mainButtonsContainer.style.bottom = '75px';
    }
  } else {
    if (miniProgramElement) {
      miniProgramElement.style.display = 'none';
    }
    if (isIOS() && pmiMeetingInfoElement) {
      // 判断是否为iphone 5s，有单独的设计稿
      if (screen.width === 320 && screen.height === 568) {
        pmiMeetingInfoElement.style.height = '448px';
        return false;
      }
    }
    if (pmiMeetingInfoElement) {
      window.pmiPageDetail.setCardContainerHeightByWidth(false);
    }
    if (!isPmi) {
      mainButtonsContainer.style.bottom = '116px';
    }
  }
};

/**
 * 是否展示电话入会入口
 * @param {*} show
 * @param {*} meetingState
 */
export const showTelJoinEntry = (show, meetingState) => {
  let $show = show;
  /**
   * SaaS 版本: !process.env.WEMEET_PARAM_PRIVATE = true
   * 私有化版本: process.env.WEMEET_PARAM_PRIVATE 有值，string
   */
  if (process.env.WEMEET_PARAM_PRIVATE) { // 私有化版本
    $show = false;
  }

  const telJoinEl = document.getElementById('telJoinBtnCtrl');
  if (!telJoinEl) {
    return;
  }
  if (!$show) {
    telJoinEl.style.display = 'none';
    return;
  }
  if (
    isMobile()
    && !isiPad()
    && !isWxworkInAndroid(navigator.userAgent)
    && (
      meetingState === MEETING_STATE.READY
      || meetingState === MEETING_STATE.ACTIVE
      || meetingState === MEETING_STATE.ENDED
    )
  ) {
    telJoinEl.style.display = isMobile() ? 'inline-block' : 'block';
  }
  if (!isMobile() || isiPad()) { // PC 端显示电话入会; 弹框展示信息
    telJoinEl.style.display = 'block';
  }
};

export const setUserLang = (val) => {
  localStorage.setItem('language', val);
};

/**
 * 获取当前用户界面语言， voov 默认英文，会议默认中文
 */
export const getUserLang = () => {
  const locale = getRequest('locale');
  const localLang = localStorage.getItem('language');
  if (locale) {
    return locale;
  } else if (localLang) {
    return localLang;
  } else {
    return getDefaultLang(); 
  }
};

/**
 * 获取当前用户界面语言供上报
 */
export const getUserLangForReport = (v = '') => {
  const LangTextMap = { en: 'English', 'zh-CN': 'Chinese' };
  if (v) {
    return LangTextMap[v];
  }
  const lang = getUserLang();
  return LangTextMap[lang];
};

/**
 * 从ls中获取默认语言
 */
export const getCurrentLanguage = () => {
  const LangTextMap = { en: 'English', 'zh-CN': '简体中文', 'zh-TW': '繁體中文', 'ru': 'русский' };
  const lang = getUserLang();
  return LangTextMap[lang];
};

/**
 * 复制邀请接口语言查询条件
 */
export const getCurrentLangForCopy = () => {
  // 暂时只支持中文和英文
  const LangTextMap = { en: 'en-us', 'zh-CN': 'zh-cn', 'zh-TW': '' };
  const lang = getUserLang();
  return LangTextMap[lang];
};

/**
 * 分享文案
 * 非当天/已结束的会议：
 * 会议时间：yyyy/mm/dd hh:mm-hh:mm
 * 会议号：xxx xxx xxx

 * 预定开始时间和结束时间之间的会议
 * 会议已经开始，请尽快加入会议。
 * 会议号：xxx xxx xxx
 */
export const getShareDes = (start, end, meetingCode) => {
  const curTime = new Date().getTime();
  let des = '';
  if (curTime >= start && curTime <= end) {
    des = '会议已经开始，请尽快加入会议\r\n';
  } else {
    des = `会议时间：${start.year}/${start.month}/${start.date} ${start.time}-${end.time}\r\n`;
  }
  des += `会议号：${meetingCode}`;
  return des;
};

/**
 * 获取默认语言
 * 1， 默认 voov en,  会议 zh-CN
 * 2,  如浏览器为简体则为 zh-CN
 * 3,  其他我 en
*/
export const getDefaultLang = () => {
  let defaultLang = IS_I18N ? 'en' : 'zh-CN';
  if (!navigator.language) {
    return defaultLang;
  }
  if (navigator.language.toLowerCase() === 'zh-cn') {
    defaultLang = 'zh-CN';
  } else {
    defaultLang = 'en';
  }
  return defaultLang;
}

/**
 * 初始化时设置默认语言，当 voov 借用会议地址后需要将语言传过去
 * 1，当浏览器已经带有语言时不设置
 * 2，未带时候先判断本地是否有语言，有的话用本地
 * 3，本地无语言时候用默认值 IS_I18N ? 'en' : 'zh-CN'
 * 4，将语言加入到浏览器地址上
 *
 */ 
export const setDefaultLocal = () => {
  const locale = getRequest('locale');
  const localStorageLang = localStorage.getItem('language');
  let localeLang = getDefaultLang();
  if (locale) return;
  if (localStorageLang) {
    localeLang = localStorageLang;
  }
  window.history.replaceState(
    null,
    document.title,
    addURLSearch(window.location.href, { locale: localeLang }),
  );
}

/**
* WindowsWechat && 版本号 > 0x63030000 && 版本号< 0x63030062
* @returns {boolean} -
*/
export const isWindowsWechatInSpecifiedVersion = (logInfo) => {
 const { userAgent } = window.navigator;

 const isWindowsWechat = /WindowsWechat/i.test(userAgent);

 /**
  * 取版本号
     0: "WindowsWechat(0x6303005e)"
     1: "0x6303005e"
  *
  * 版本号 > 0x63030000 && 版本号< 0x63030062
  *  (0x63030000, 0x63030062)
  */
 let winWechatVersion = userAgent.match(/WindowsWechat\((.*)\)/i);
 if (winWechatVersion && winWechatVersion.length > 0) {
   winWechatVersion = Number(winWechatVersion[1]);
 } else {
   winWechatVersion = 0;
 }
 const region = [0x63030000, 0x63030062];

 const res = (
   isWeChat()
   && isWindowsWechat
   && (parseInt(winWechatVersion, 10) > parseInt(region[0], 10))
   && (parseInt(winWechatVersion, 10) < parseInt(region[1], 10))
 );

 if (typeof logInfo === 'function') {
   logInfo('isWindowsWechatInSpecifiedVersion', {
     isWeChat: isWeChat(),
     isWindowsWechat,
     winWechatVersion,
     res,
     winWechatVersionNum: parseInt(winWechatVersion, 10),
     region1: parseInt(region[0], 10),
     region2: parseInt(region[1], 10),
   });
 }

 return res;
};

export const getTapiPrefix = () => {
  let prefix = 'https://voovmeeting.com/';
  if (isLocalEnv() || isTestEnv()) {
    prefix = 'https://test.web.voovmeeting.com/';
  } else if (isPreReleaseEnv()) {
    // prefix = 'https://test.web.voovmeeting.com/'; // todo: voov目前还没有集成测试环境
  }
  return prefix;
};

export const queryInviteContent = ({
  meetingId = '',
  subMeetingId = '',
  ability = 15,
  isSharePage = 0,
  language = 'zh-cn',
  pmiCode = '',
}) => {
  const params = {
    meeting_id: meetingId,
    sub_meeting_id: subMeetingId,
    ability,
    is_share_page: isSharePage,
    language,
    pmi_code: pmiCode,
  };

  return $http
    .post({
      url: `${getTapiPrefix()}wemeet-tapi/wemeet/manage_service_not_auth/comm/v1/query_invite_content`,
      data: params,
    });
};
